export default __webpack_public_path__ + "static/media/hdb-flat-4.b960030f.svg";